import React, {SyntheticEvent, useState} from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography} from "@mui/material";
import AddFundingSourceForm from "./AddFundingSourceForm";
import {createAccountFundingSource} from "./user/request/user-requests";
import Busy from "./Busy";
import {getErrorMessageForNonStandardAndStandardResponse} from "../util/NetworkErrorUtil";
import MicrodepositVerificationSteps from "./paymentMethods/MicrodepositVerificationSteps";
import {removeInitialSpecialChars} from "../util/sanitizeUtil";
import {styled} from "@mui/material/styles";

const FundingSourceDialogActions = styled(DialogActions)(({theme}) => ({
  backgroundColor: theme.palette.grey[100]
}));

const MicrodepositVerificationStepsDialogContent = () => {
  return (
    <>
      <Typography variant={'h6'} component={'h2'}>Bank Account Verification Still Required</Typography>
      <MicrodepositVerificationSteps />
    </>
  );
};

const PartnerAddFundingSourceDialog = (props) => {
  const {account, open, onClose, onSuccess} = props;
  const [accountType, setAccountType] = useState('');
  const [routingNumber, setRoutingNumber] = useState('');
  const [accountNumber, setAccountNumber] = useState('');
  const [confirmAccountNumber, setConfirmAccountNumber] = useState('');
  const [nickName, setNickName] = useState('');
  const [errorMsg, setErrorMsg] = useState('');

  const [showMicrodepositVerificationDialog, setShowMicrodepositVerificationDialog] = useState(false);
  const [response, setResponse] = useState();

  const resetForm = () => {
    setAccountType('');
    setRoutingNumber('');
    setAccountNumber('');
    setConfirmAccountNumber('');
    setNickName('');
    setErrorMsg('');
    setResponse(undefined);
  };

  const handleChange = (event) => {
    const name = event.target.name;
    let value = event.target.value;
    if (name !== 'accountType' && name !== 'nickName') {
      const regex = new RegExp(/\D/);
      if (regex.test(value)) {
        return;
      }
    }
    value = removeInitialSpecialChars(event.target.value);
    switch (name) {
      case 'accountType':
        setAccountType(value);
        break;
      case 'routingNumber':
        setRoutingNumber(value);
        break;
      case 'accountNumber':
        setAccountNumber(value);
        break;
      case 'confirmAccountNumber':
        setConfirmAccountNumber(value);
        break;
      case 'nickName':
        setNickName(value);
        break;
      default:
        break;
    }
  };

  const validateForm = () => {
    if (!accountType) {
      setErrorMsg('Please select an account type');
      return false;
    }
    if (!routingNumber || !accountNumber || !confirmAccountNumber || !nickName.trim()) {
      setErrorMsg('Please enter the required account information.');
      return false;
    }
    setErrorMsg('');
    return true;
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    const formIsValid = validateForm();
    if (!formIsValid) {
      return;
    }
    const body = {
      id: account.id,
      newFundingSourceBankAccountType: accountType,
      newFundingSourceBankRoutingNumber: routingNumber,
      newFundingSourceBankAccountNumber: accountNumber,
      newFundingSourceAccountNickname: nickName
    }
    Busy.set(true);
    createAccountFundingSource(body).then((response) => {
      setShowMicrodepositVerificationDialog(true);
      setResponse(response.body);

      onSuccess(response);
      resetForm();
    }).catch((error) => {
      setErrorMsg(getErrorMessageForNonStandardAndStandardResponse(error));
    }).finally(() => Busy.set(false));
  };

  const handleCloseVerificationSteps = () => {
    setShowMicrodepositVerificationDialog(false);
    onSuccess(response);
    resetForm();
  }

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const ariaLabelledBy = 'ss-add-funding-source-title';
  const ariaDescribedBy = 'ss-funding-source-form';
  const formId = 'ss-add-funding-source-form';
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby={ariaLabelledBy}
      aria-describedby={ariaDescribedBy}
    >
      <DialogTitle id={ariaLabelledBy} variant={'h6'} component={'h2'}>
        Add Bank Account
      </DialogTitle>
      <DialogContent id={ariaDescribedBy}>
        {
          showMicrodepositVerificationDialog ?
            <MicrodepositVerificationStepsDialogContent ariaDescribedBy={ariaDescribedBy} />
            :
            <>
              <AddFundingSourceForm
                formId={formId}
                accountType={accountType}
                routingNumber={routingNumber}
                accountNumber={accountNumber}
                confirmAccountNumber={confirmAccountNumber}
                nickName={nickName}
                onChange={handleChange}
                onSubmit={handleSubmit}
              />
              {
                errorMsg &&
                <Typography variant={'body1'} color={'error'} align={'center'}>{errorMsg}</Typography>
              }
            </>
        }
      </DialogContent>
      <FundingSourceDialogActions>
        {
          showMicrodepositVerificationDialog ?
            <Button color={'primary'} onClick={handleCloseVerificationSteps}>Close</Button>
            : <>
            <Button color={'primary'} onClick={handleClose}>Cancel</Button>
            <Button color={'primary'} type={'submit'} onClick={handleSubmit} form={formId}>Save Bank Account</Button>
          </>
        }
      </FundingSourceDialogActions>
    </Dialog>
  );
};

export default PartnerAddFundingSourceDialog;
